// @flow
import { noop, isFunction } from './utils';

import type { Player$Logger } from './types/Logger';

/* eslint no-console:0 */

export type Level = 0 | 1 | 2 | 3 | 4

const DEFAULT_LOG_LEVEL: Level = 2;

function _createLog(type: $Keys<Player$Logger>) {
   return window.console ? _inner : noop;

   function _inner(...args: Array<mixed>) {
      if (type in console && isFunction(console[type])) {
         args.unshift( (new Date()).toString() );
         console[type].apply(console, args);
      }
   }
}

export default function createLogger(level: Level = DEFAULT_LOG_LEVEL): Player$Logger {
   let idx = 1;
   const logger = {};
   logger.debug = ++idx > level ? _createLog('debug') : noop;
   logger.log   = ++idx > level ? _createLog('log')   : noop;
   logger.warn  = ++idx > level ? _createLog('warn' ) : noop;
   logger.error = ++idx > level ? _createLog('error') : noop;
   return logger;
}
